import { render, staticRenderFns } from "./CallbackLoading.vue?vue&type=template&id=3ebc660e&scoped=true&"
import script from "./CallbackLoading.vue?vue&type=script&lang=js&"
export * from "./CallbackLoading.vue?vue&type=script&lang=js&"
import style0 from "./CallbackLoading.vue?vue&type=style&index=0&id=3ebc660e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebc660e",
  null
  
)

export default component.exports